import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { queryStringService } from "../../../Application/utils/queryStringService";
import { Routes } from "../../../common/routes";
import { EntityType } from "../../../common/types";
import { PriorityLevel } from "../../../AssetResults/types";
import { type HomePageContentItem } from "../../types";
import { CategoryItem } from "../CategoryItem/CategoryItem";
import styles from "./CategoriesStacks.module.scss";

const cx = classNames.bind(styles);

export interface Props {
  items: HomePageContentItem[];
  showBorder: boolean;
  priorityLevel: PriorityLevel;
}

export const CategoriesStacks: React.FC<Props> = ({ items, showBorder, priorityLevel }) => {
  const { t } = useTranslation(["application", "discover"]);

  const priorityLabel: { [key in PriorityLevel]: string } = {
    [PriorityLevel.None]: t("priority.none", { ns: "discover" }),
    [PriorityLevel.Normal]: `${t("priority.normal", { ns: "discover" })} Courses`,
    [PriorityLevel.Important]: `${t("priority.important", { ns: "discover" })} Courses`,
    [PriorityLevel.Required]: `${t("priority.required", { ns: "discover" })} Courses`,
  };

  const getPriorityFilter = (priority: PriorityLevel): any => {
    return { appliedFilters: { entityType: [EntityType.Flow], priority: [priority] } };
  };

  return (
    <div className={cx(styles.root, { [styles.noBorder]: !showBorder })}>
      {items && items.length > 0 ? (
        items.map(item => <CategoryItem item={item} key={item.id} completionStatus={item.completionStatus} />)
      ) : (
        <div>There are no assigned items with the current priority</div>
      )}
      <div className={styles.viewAll}>
        <Link
          to={`${Routes.Discover.exact}?${queryStringService.stringify(getPriorityFilter(priorityLevel))}`}
          data-testid="view-all"
          aria-label={t("common.viewAllAssetType", {
            item: priorityLabel[priorityLevel],
            ns: "application",
          })}
        >
          {t("common.viewAll", { ns: "application" })}
        </Link>
      </div>
    </div>
  );
};
